import { Injectable } from '@angular/core';
import { Subject, Observable, Subscription } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BusinessNavKeybindService {
  private keyEvent$$: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();
  public keyEvent$: Observable<KeyboardEvent> = this.keyEvent$$.asObservable();
  private _listItemSubscription: Subscription;

  public triggerKeyEvent(event: KeyboardEvent): void {
    this.keyEvent$$.next(event);
  }

  public setOrUpdateListItemActiveSubscription(sub: Subscription): void {
    if (!!this._listItemSubscription) {
      this._listItemSubscription.unsubscribe();
    }
    this._listItemSubscription = sub;
  }
}
